import DepartmentListWithCounts from './Request/Department_listWithCounts';

const mapDepartmentList = departmentlist =>
  (departmentlist || []).map(department => ({
    id: department.id,
    name: department.name,
    numberOfEmployees: department.numberOfEmployees,
    numberOfCourses: department.numberOfCourses,
    // Booleano, no la etiqueta ya escrita: quien pinta la fila es quien sabe en
    // qué idioma está la pantalla.
    active: Boolean(department.status),
  }));

const DepartmentsList = async () => {
  const departments = await DepartmentListWithCounts();
  return { departmentsList: mapDepartmentList(departments) };
};

export default DepartmentsList;
